module.exports = __webpack_public_path__ + "static/media/repeat.af895506.svg";